var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.29115C5 4.44495 4.93998 4.59874 4.82018 4.716L1.0486 8.40598C0.808678 8.64071 0.419689 8.64071 0.179867 8.40598C-0.0599556 8.17135 -0.0599556 7.79085 0.179867 7.5561L3.51717 4.29115L0.179984 1.02619C-0.059839 0.791457 -0.059839 0.410995 0.179984 0.176378C0.419806 -0.0584669 0.808794 -0.0584669 1.04871 0.176378L4.8203 3.8663C4.94011 3.98362 5 4.13741 5 4.29115Z",
    fill: "#484964"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.3528f42e12ce861fd31405f99a730fb2.svg";
export { ForwardRef as ReactComponent };